module.exports = __webpack_public_path__ + "img/avatar.36b7a6db.png";